import React from "react";
import moodmapLogo from "../assets/moodmap.png"
import soulstepsLogo from "../assets/soulsteps.png"
import meshBackground from "../assets/mesh.jpg"
import iconMoodlinge from "../assets/icon_moodlinge.svg"
import Translation from "../i18n";

class Header extends React.Component {

    render() {
        return (
            <div className="container-fluid px-0 header">
                <div className="container py-2">
                    <div className="row align-items-center">
                        <div className="col-4 text-left">
                            <a href="https://www.soulsteps.at" target="_blank" rel="noreferrer">
                                <img src={soulstepsLogo} className="img-fluid brand" alt="" />
                            </a>
                        </div>
                        <div className="col-4 text-center">
                            <a href="https://www.moodmap.at" target="_blank" rel="noreferrer">
                                <img src={moodmapLogo} className="img-fluid brand" alt="" />
                            </a>
                        </div>
                        <div className="col-4 text-end">
                            <img src={iconMoodlinge} className="img-fluid brand" alt="" />
                        </div>
                    </div>
                </div>
                <div className="position-relative static-header">
                    <div className="position-absolute w-100 h-100">
                        <div className="container h-100">
                            <div className="row h-100 align-items-center">
                                <div className="col-12 text-center">
                                    {/*<h1>{this.props.title}</h1>*/}
                                    <h1>
                                        <Translation i18n="questionnaireHeader" />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={meshBackground} className="img-fluid mesh" alt="" />
                </div>
            </div>
        );
    }
}

export default Header;
